import { render, staticRenderFns } from "./TranslationSettingsModal.vue?vue&type=template&id=45719574&scoped=true"
import script from "./TranslationSettingsModal.vue?vue&type=script&lang=js"
export * from "./TranslationSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./TranslationSettingsModal.vue?vue&type=style&index=0&id=45719574&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45719574",
  null
  
)

export default component.exports